import { render, staticRenderFns } from "./TableMundialGroupInformador.vue?vue&type=template&id=580e67c2&scoped=true&"
import script from "./TableMundialGroupInformador.vue?vue&type=script&lang=js&"
export * from "./TableMundialGroupInformador.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialGroupInformador.vue?vue&type=style&index=0&id=580e67c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e67c2",
  null
  
)

export default component.exports